//utils
import axios from 'axios';
//types
import {PublicEventType} from 'enums/public_event_type';
import type {Dispatch} from 'redux';
import ActionType from 'store/actionTypes';
import {IPublicEvent} from 'types/publicEvent';

interface GetListProps {
  type?: PublicEventType;
  date: string;
  view?: string;
  facility: string;
  memberId?: string;
}

export const getList = async (params: GetListProps, dispatch: Dispatch): Promise<any> => {
  const response = await axios.get('/public-events', {params});
  let {events} = response.data;

  if (!params.view) {
    params.view = '3days+cache';
  }

  if (!events) {
    events = response.data;
  }

  const list = events.map((event: IPublicEvent, index: number) => ({
    ...event,
    index,
  }));

  dispatch({type: ActionType.GET_PUBLIC_EVENTS_SUCCESS, data: {list, date: params.date, facility: params.facility}});

  return list;
};
